import React from 'react';
import { Chip, useT } from '@repo/common';

const STATUS_KR = {
  Upcoming: '예정',
  Waitlist: '대기',
  Saved: '찜',
  Past: '지난 워크숍',
};

const MyWorkshopsHeaderButton = ({
  currentFilter,
  onFilterChange,
  hasAnyWorkshop,
}) => {
  const t = useT();
  const workshopStatuses = ['Upcoming', 'Waitlist', 'Saved', 'Past'];

  const statusMapper = {
    Upcoming: 'Upcoming',
    Waitlist: 'Waitlist',
    Saved: 'Saved',
    Past: 'Past',
  };

  return (
    <div className='flex items-center gap-2 pb-4 tabletH:pb-6 w-full'>
      {workshopStatuses.map((status) => {
        const mappedValue = statusMapper[status];
        const isSelected = currentFilter === mappedValue;
        const isDisabled =
          !hasAnyWorkshop && mappedValue !== 'ALL' && !isSelected;

        return (
          <Chip
            key={status}
            type='fill'
            state={
              isDisabled ? 'disabled' : isSelected ? 'selected' : 'default'
            }
            hideIcon={true}
            onClick={() => {
              if (!isDisabled) {
                onFilterChange(mappedValue);
              }
            }}
            borderclass='ring-0'
          >
            {t(status, STATUS_KR[status])}
          </Chip>
        );
      })}
    </div>
  );
};

export default MyWorkshopsHeaderButton;
